var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyTrades(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.5 55C107.5 83.9949 83.9949 107.5 55 107.5C26.0051 107.5 2.5 83.9949 2.5 55C2.5 26.0051 26.0051 2.5 55 2.5C83.9949 2.5 107.5 26.0051 107.5 55Z",
    stroke: "#CCCCCC",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 68.5V54.7422L33.1212 60.1212L31 58L40 49L49 58L46.8789 60.1212L41.5 54.7422V68.5H59.5V71.5H41.5C40.7046 71.499 39.9421 71.1827 39.3797 70.6203C38.8173 70.0579 38.501 69.2954 38.5 68.5Z",
    fill: "#4A4A4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67 64H73C73.7954 64.0008 74.558 64.3171 75.1204 64.8796C75.6829 65.442 75.9992 66.2046 76 67V73C75.9992 73.7954 75.6829 74.558 75.1204 75.1204C74.558 75.6829 73.7954 75.9992 73 76H67C66.2046 75.9992 65.442 75.6829 64.8796 75.1204C64.3171 74.558 64.0008 73.7954 64 73V67C64.0008 66.2046 64.3171 65.442 64.8796 64.8796C65.442 64.3171 66.2046 64.0008 67 64V64ZM73 73V67H66.9978L67 73H73Z",
    fill: "#4A4A4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 40V53.7578L76.8788 48.3789L79 50.5L70 59.5L61 50.5L63.1212 48.3789L68.5 53.7578V40H50.5V37H68.5C69.2954 37.001 70.0579 37.3173 70.6203 37.8797C71.1827 38.4421 71.499 39.2046 71.5 40Z",
    fill: "#4A4A4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 40H34V43H43V40Z",
    fill: "#4A4A4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46 34H34V37H46V34Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTrades);
export default __webpack_public_path__ + "static/media/empty_trades.f36c29d1a077dbedbe796c42b239f487.svg";
export { ForwardRef as ReactComponent };